
//郢ｧ�ｹ郢ｧ�ｯ郢晢ｽｭ郢晢ｽｼ郢晢ｽｫ邵ｺ�ｽ100邵ｺ�ｫ鬩墓鱒��邵ｺ貅假ｽ臥ｹ晄㈱縺｡郢晢ｽｳ髯ｦ�ｨ驕会ｽｺ
$(function() {
    var topBtn = $('#page-top');
    topBtn.hide();
    //郢ｧ�ｹ郢ｧ�ｯ郢晢ｽｭ郢晢ｽｼ郢晢ｽｫ邵ｺ�ｽ100邵ｺ�ｫ鬩墓鱒��邵ｺ貅假ｽ臥ｹ晄㈱縺｡郢晢ｽｳ髯ｦ�ｨ驕会ｽｺ
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            topBtn.fadeIn();
        } else {
            topBtn.fadeOut();
        }
    });
    //郢ｧ�ｹ郢ｧ�ｯ郢晢ｽｭ郢晢ｽｼ郢晢ｽｫ邵ｺ蜉ｱ窶ｻ郢晏現繝｣郢晢ｿｽ
    topBtn.click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });
  
});

	$(function(){
		//クリックで動く
		$('.nav-open').click(function(){
			$(this).toggleClass('active');
			$(this).next('nav').slideToggle();
		});
	});

$(function () {
	$(window).scroll(function () {
		// 画面スクロールの位置を取得
		var scroll = $(window).scrollTop();

		// スクロール位置が200pxを超えると追従ヘッダーを表示
		if (scroll > 200) {
			$('.header-scroll-visible').addClass('is-show');
            $('.header-scroll-hidden').addClass('is-hidden');
		}
		else {
			$('.header-scroll-visible').removeClass('is-show');
            $('.header-scroll-hidden').removeClass('is-hidden');
		}
	});
});

//郢晁ｼ斐♂郢晢ｽｼ郢晏ｳｨ縺�ｹ晢ｽｳ
$(function(){
    $(window).scroll(function (){
        $('.fade').each(function(){
            var elemPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > elemPos - windowHeight + 130){
                $(this).addClass('scr');
            }
        });
    });
});


//郢ｧ�ｹ郢晢ｽｩ郢ｧ�､郢敖郢晢ｽｼ
$(function() {
  $('.slider').slick({
      asNavFor: '.slider-nav',
      autoplaySpeed: 3000,
      autoplay: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      adaptiveHeight: true,
      centerPadding: '50px',
      arrows: true,
      variableWidth: true,
      draggable: false,
      responsive: [{
          breakpoint: 1025,
          settings: {
              centerPadding: '0',
              variableWidth: false
          }
      }]
  });

  if ((navigator.userAgent.indexOf('iPhone') > 0 && navigator.userAgent.indexOf('iPad') == -1) || navigator.userAgent.indexOf('iPod') > 0 || navigator.userAgent.indexOf('Android') > 0) {
    $('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.slider',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    arrows: false,
    });
  } else {
    $('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.slider',
    dots: false,
    centerMode: true,
    waitForAnimate:false,
    focusOnSelect: true,
    arrows: false,
    });
  }
});

$(window).on('load',function(){
  $('li.question').on('click', function () {
    $(this).children(".question-trigger").toggleClass("active").next().stop().slideToggle();
  });
  var slideNum = $('.slide').length;
  var swiper = new Swiper('.mvslider', {
    loop:true,
    autoplay: {
      delay: 3000, // 騾泌�繧後↑縺上Ν繝ｼ繝�
    },
		slidesPerView: 2,
		centeredSlides: true,
		initialSlide: 1,
    breakpoints: {
      // 繧ｹ繝ｩ繧､繝峨�陦ｨ遉ｺ譫壽焚��500px莉･荳翫�蝣ｴ蜷�
      500: {
        slidesPerView: 1,
      }
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
    init_tooltip();
});
$(function(){
  $(".menu-parent").hover(function(){
    $(this).children(".sub-menu").stop().slideToggle();
   });
 });
 $(function(){
  $(".menu-dropdown-icon").hover(function(){
    $(this).children("#search-wrap").stop().slideToggle();
   });
 });

function init_tooltip(){
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  }) 
}

(function(window, document) {
  const animTime = 5000; // 繧｢繝九Γ繝ｼ繧ｷ繝ｧ繝ｳ譎る俣(ms)
  const speed = 100; // 繝�く繧ｹ繝医�遘ｻ蜍暮溷ｺｦ(px)
  const limit = 0; // 繝悶Ξ繝ｼ繧ｯ繝昴う繝ｳ繝�(px)
  let animId;
  let isRunning = false;

  //const ticker = document.querySelector('.ticker');
  //loadTicker();

  function loadTicker() {
    //tickerAnim();
    //animId = setInterval(tickerAnim, animTime);
    isRunning = true;
  }

  // 繧｢繝九Γ繝ｼ繧ｷ繝ｧ繝ｳ蜃ｦ逅�
  function tickerAnim() {
    const items = ticker.querySelectorAll('.ticker-item');
    const running = ticker.querySelector('.run');
    let idx, link, first, next;
    if (!running) { // 螳溯｡御ｸｭ縺ｮ隕∫ｴ�縺後↑縺��ｴ蜷茨ｼ亥�蝗槭�縺ｿ��
      first = items[0];
      link = first.querySelector('a');
      first.classList.add('fadeInDown', 'run');
      first.style.zIndex = 1;
      setTimeout(textMove, 1000, link); // 隨ｬ3蠑墓焚縺ｫ蠑墓焚link繧呈欠螳壹ゅ％縺�＠縺ｪ縺�→蜊ｳ螳溯｡後＆繧後※縺励∪縺��縺ｧ豕ｨ諢上�
    } else {
      for (let i = 0; i < items.length; i++) {
        if (items[i] == running) {
          idx = i; // 螳溯｡御ｸｭ隕∫ｴ�縺ｮ繧､繝ｳ繝�ャ繧ｯ繧ｹ繧貞叙蠕�
          break;
        }
      }
      next = items[(idx + 1) % items.length];
      running.classList.replace('fadeInDown', 'fadeOutDown');
      setTimeout(() => {
        running.classList.remove('fadeOutDown', 'run');
        running.style.zIndex = 0;
        link = running.querySelector('a');
        link.style.transform = 'none';
        next.classList.add('fadeInDown', 'run');
        next.style.zIndex = 1;
        link = next.querySelector('a');
        setTimeout(textMove, 1000, link);
      }, 300);
    }
  }

  // 繝�く繧ｹ繝育ｧｻ蜍募�逅�
  function textMove(elm) {
    const move = elm.parentNode.clientWidth - elm.clientWidth;
    if (move < 0) {
      elm.style.transform = 'translateX(' + move + 'px)';
      elm.style.transitionDuration = Math.abs(move) / speed + 's';
    }
  }

  // 繧ｦ繧｣繝ｳ繝峨え繧ｵ繧､繧ｺ螟画峩譎�
  window.addEventListener('resize', () => {
    const windowWidth = window.innerWidth;
    if (windowWidth <= limit) {
      //ticker.style.display = 'none';
      //clearInterval(animId);
      isRunning = false;
    } else {
      if (!isRunning) {
        //ticker.style.display = 'block';
        //animId = setInterval(tickerAnim, animTime);
        isRunning = true;
      }
    }
  });
})(window, document);